import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Calendar } from 'react-big-calendar';


export const RootContainer = styled(Grid)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
}));

export const ViewContainer = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-outlinedSizeSmall': {
        padding: theme.spacing(0.75, 1),
        borderColor: '#E8E8E8',
    },
}));

export const ViewText = styled(Grid)(() => ({ marginRight: '10px' }));

export const ViewMapButtonGroup = styled(ButtonGroup)(() => ({ display: 'inline-flex' }));

export const ViewMapButton = styled(Button)(() => ({
    padding: '6px 2px',
    borderColor: '#E8E8E8',
    paddingTop: '1px',
    paddingBottom: '0px',
}));

export const ConfirmActionBtn = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    border: 'none',
    padding: '4px 20px',
    textTransform: 'none',
    margin: theme.spacing(2),
    backgroundColor: "#638dff",

    color: '#FFFFFF',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    boxShadow: 'none',
    '&:hover': { backgroundColor: "#4c71d6" },
    '&:focus': { boxShadow: '0 0 6px 0 #638dff !important' },
    '&:disabled': {
        backgroundColor: '#aeb8d6',
        color: '#e8ecf8',
    },
}));

export const Title = styled(Typography)(({ theme }) => ({
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    fontSize: '20px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '-0.51px',
    color: '#2a2d3c',
}));

export const CalendarContainer = styled(Calendar)(() => ({
    backgroundColor: '#ffffff',
    padding: '11px 0 0px',
    borderRadius: 20,
    '& .rbc-month-view': {
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
    },
    '& .rbc-header span': { fontWeight: 'normal' },
    '& .rbc-off-range-bg': { backgroundColor: '#fff' },
    '& .rbc-date-cell': { fontWeight: 'bold' },
    '& .rbc-button-link': { fontWeight: 'bold' },
    '& .rbc-show-more': { color: '#638dff' },
    '& .rbc-row-segment': { flexBasis: '14.3%' },
    '& .rbc-day-slot .rbc-time-slot:nth-child(2)': { borderTop: '1px solid #f4f4f4' },
    '& .rbc-timeslot-group': { backgroundColor: '#fff' },
    '& .rbc-events-container .rbc-event': { border: '1px solid #fff' },
    '& .rbc-current-time-indicator': { backgroundColor: '#00A7D6' },
    '& .rbc-allday-cell': { display: 'none' },
    '& .rbc-header.rbc-today': { border: 'none' },
}));
